export default __webpack_public_path__ + "../staticImages/sprite-forecast-dhl_eu.png";